/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Copied_To_ClipboardInputs */

const en_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const de_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const fr_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const es_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const it_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const nl_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const pl_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const fi_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const da_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

const sv_negotiation_copied_to_clipboard = /** @type {(inputs: Negotiation_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Script copied to clipboard" |
*
* @param {Negotiation_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_copied_to_clipboard = /** @type {((inputs?: Negotiation_Copied_To_ClipboardInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Copied_To_ClipboardInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_copied_to_clipboard(inputs)
	if (locale === "fr") return fr_negotiation_copied_to_clipboard(inputs)
	if (locale === "es") return es_negotiation_copied_to_clipboard(inputs)
	if (locale === "it") return it_negotiation_copied_to_clipboard(inputs)
	if (locale === "nl") return nl_negotiation_copied_to_clipboard(inputs)
	if (locale === "pl") return pl_negotiation_copied_to_clipboard(inputs)
	if (locale === "fi") return fi_negotiation_copied_to_clipboard(inputs)
	if (locale === "da") return da_negotiation_copied_to_clipboard(inputs)
	if (locale === "sv") return sv_negotiation_copied_to_clipboard(inputs)
	return en_negotiation_copied_to_clipboard(inputs)
});